var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#F1F5FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_502_27868)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.33333 10C9.33333 9.63267 9.63267 9.33333 10 9.33333H15.3333V14H20V14.67C20.3907 14.382 20.848 14.1813 21.3333 14.0853V13.0573L16.276 8H10C8.89733 8 8 8.89733 8 10V24H14V22.6667H9.33333V10ZM16.6667 10.276L19.0573 12.6667H16.6667V10.276ZM23.4147 15.9193C22.6587 15.1633 21.3413 15.1633 20.586 15.9193L15.3333 21.1713V24H18.162L23.414 18.748C23.792 18.37 24 17.868 24 17.3333C24 16.7987 23.792 16.2967 23.4147 15.9193ZM22.4713 17.8047L17.61 22.6667H16.6667V21.7233L21.5287 16.862C21.78 16.61 22.2193 16.61 22.4713 16.862C22.5973 16.9873 22.6667 17.1547 22.6667 17.3333C22.6667 17.512 22.5973 17.6787 22.4713 17.8047Z",
    fill: "#2E5BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_27868"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequest);
export default __webpack_public_path__ + "static/media/request.c3a02dfe.svg";
export { ForwardRef as ReactComponent };